import React from "react";
import "../css/Card.css";

function Card(props) {
  return (
    <div>
      <div class="card" id={props.color}>
        <div class="card-div">
          <img src={props.image} class="card-img" />
          <p class="card-title">{props.title}</p>
        </div>
      </div>
    </div>
  );
}

export default Card;
